import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
export const getCallTabUrl = (portalId, queryString) => {
  const subdomainPrefix = enviro.deployed() ? 'app' : 'local';
  return `${getFullUrl(subdomainPrefix)}/calling-page-application/${portalId}?${queryString}`;
};